// TODO: add the porterbuddy color palette here.
export const COLOR = {
  PRIMARY: 'rgba(21,100,116,1)',
  PRIMARY_LIGHT: 'rgba(199, 246, 255,1)',
  PRIMARY_TRANSPARENT: 'rgba(21,100,116,0.2)',
  GREEN: '#55ab6d',
  WHITE: 'rgb(255,255,255)',
  WHITE_GRAY: '#FBFBFB',
  RED: 'rgb(255,0,0)',
  DARK_GREY: '#333333',
  LIGHT_GREY: '#F2F2F2',
  GRAY: '#5f5f5f',
  DARK_GRAY: '#4d4d4d',
  LIGHT_GRAY: 'rgb(155,155,155)',
  LIGHTER_GRAY: '#C4C4C4',
  BLACK: '#232323',
  YELLOW: '#ffc247',
  SHIFT_YELLOW: '#EDC231',
  SHIFT_GREEN: '#46AD6D',
  SHIFT_RED: '#DD6C62',
  SHIFT_GRAY: '#707070',
  TEXT_GREY: '#555',
  PROGRESS_RED: '#dd4912',
  PROGRESS_YELLOW: '#ffe200',
  PROGRESS_GREEN: '#0eb227',
  PROGRESS_PURPLE: '#FF8AFE',
  PROGRESS_BLACK: 'black',
  MULTI_BUNDLE: '#64c864',
};

/* Note :
 * The `MAX_CONTRAST_COLORS` and `kelly_colors` should avoid the Red/Pink color usage.
 * Because currently the Red/Pink used for marking the `Selection` for Bundle Marker
 */
// Kenneth Kelly's 22 colors of maximum contrast https://gist.github.com/ollieglass/f6ddd781eeae1d24e391265432297538
// (some dark colors skipped, commented out below)
export const MAX_CONTRAST_COLORS = [
  'rgba(243,195,0, 1)',
  'rgba(135,86,146, 1)',
  'rgba(243,132,0, 1)',
  'rgba(161,202,241, 1)',
  'rgba(0,139,139, 1)',
  'rgba(194,178,128, 1)',
  'rgba(132,132,130, 1)',
  'rgba(0,136,86, 1)',
  'rgba(143,188,143, 1)',
  'rgba(0,103,165, 1)',
  'rgba(249,147,121, 1)',
  'rgba(96,78,151, 1)',
  'rgba(246,166,0, 1)',
  'rgba(119,136,153,1)',
  'rgba(220,211,0, 1)',
  'rgba(106,90,205, 1)',
  'rgba(141,182,0, 1)',
  'rgba(101,69,34, 1)',
  'rgba(226,88,34, 1)',
];

export const kelly_colors = [
  // '#F2F3F4',
  // '222222',
  '#F3C300',
  '#875692',
  '#F38400',
  '#A1CAF1',
  '#008b8b',
  '#C2B280',
  '#848482',
  '#008856',
  '#8fbc8f',
  '#0067A5',
  '#F99379',
  '#604E97',
  '#F6A600',
  '#778899',
  '#DCD300',
  '#6a5acd',
  '#8DB600',
  '#654522',
  '#E25822',
  // '2B3D26',
];
